export const idlFactory = ({ IDL }) => {
  const Hash = IDL.Nat32;
  return IDL.Service({
    'addAnswers' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        [],
        ['oneway'],
      ),
    'addAnswersPass' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)), IDL.Text],
        [],
        ['oneway'],
      ),
    'addQuestion' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Vec(IDL.Text)],
        [],
        ['oneway'],
      ),
    'addQuestionPass' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text, IDL.Vec(IDL.Text), IDL.Text],
        [],
        ['oneway'],
      ),
    'addQuestionSet' : IDL.Func([IDL.Text], [], ['oneway']),
    'addQuestionSetPass' : IDL.Func([IDL.Text, IDL.Text], [], ['oneway']),
    'checkSetExistsPass' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Bool, IDL.Opt(Hash)],
        ['query'],
      ),
    'clearData' : IDL.Func([IDL.Text], [], ['oneway']),
    'clearDataPass' : IDL.Func([IDL.Text, IDL.Text], [], ['oneway']),
    'getExistingSets' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'getExistingSetsPass' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Text)],
        ['query'],
      ),
    'getQuestions' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text, IDL.Vec(IDL.Text)))],
        ['query'],
      ),
    'getQuestionsPass' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text, IDL.Vec(IDL.Text)))],
        ['query'],
      ),
    'getResults' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))))],
        ['query'],
      ),
    'getResultsPass' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))))],
        ['query'],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
